import ConditionFilterModel from "../../../filters/filter/ConditionFilterModel.js";
export default {
  type: 'condition.Filter',
  convert: (value, context) => {
    const {
      filterConverterFactory
    } = context;
    const rootCondition = ConditionFilterModel.getRootCondition(value);
    const converted = filterConverterFactory.create(rootCondition, {
      ...context,
      isRootCondition: true
    });
    if (!converted) {
      return null;
    }
    return converted;
  }
};